import { IProcessingOutput } from './i-processing-output';
import { SelectableData } from './selectable-data';

export class InputProcessor {
	private readonly separator: string;

	public constructor(separator?: string | undefined) {
		this.separator = separator ?? ',';
	}

	public process(input: string, selectableData: readonly SelectableData[]): IProcessingOutput {
		const inputStrings = new Set<string>(this.determineStringsToMatch(input));
		const matchedFilter = selectableData.filter((el) => inputStrings.has(this.normalize(el.matchString)));
		const outputKeys = matchedFilter.map((el) => el.outputKey);

		const unmatchedInput = this.determineStringsToMatch(input).filter(
			(el) => !selectableData.find((element) => this.normalize(element.matchString) === el)
		);

		return { outputKeys, unmatchedInput };
	}

	public determineInput(
		outputKeys: readonly string[],
		unmatchedInput: readonly string[],
		selectableData: readonly SelectableData[]
	): string {
		const keys = new Set<string>(outputKeys);
		const matchStrings = selectableData.filter((d) => keys.has(d.outputKey)).map((d) => d.matchString);

		return [...unmatchedInput, ...matchStrings].join(this.separator);
	}

	private determineStringsToMatch(input: string): readonly string[] {
		return input
			.split(this.separator)
			.map((el) => this.normalize(el))
			.filter((f) => f.length > 0);
	}

	private normalize(input: string): string {
		return input.trim().toLowerCase();
	}
}
